export default __webpack_public_path__ + "static/media/i21.2e8933ba.jpeg";